import MarketingNav from "@/components/MarketingNav";

export default function AppLayout({ children }) {
  return (
    <>
      <div className="min-h-ful marketing-bg-gradient">
        <MarketingNav></MarketingNav>
        <main>
          <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
      <div className="py-14 marketing-footer">
        <div className="flex justify-center">
          <svg
            className="mktg-logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.286 15c-1.104 0-1.88-.65-2.629-1.416l.622-.78c.577.662 1.175 1.196 2.007 1.196 1.057 0 1.739-.789 1.739-2s-.683-2-1.739-2c-2.368 0-3.569 5-6.571 5-1.599 0-2.715-1.227-2.715-3s1.116-3 2.715-3c1.105 0 1.881.65 2.631 1.417l-.622.781c-.578-.663-1.176-1.198-2.009-1.198-1.057 0-1.74.789-1.74 2s.684 2 1.74 2c2.364 0 3.562-5 6.571-5 1.599 0 2.714 1.227 2.714 3s-1.115 3-2.714 3z" />
          </svg>
        </div>
        <h3 className="w-11/12 mx-auto max-w-4xl marketing-text-gradient  text-2xl lg:text-4xl font-bold text-center mt-12 mb-4 mx-auto">
          Subscribe for early access
        </h3>
        <p className="text-gray-200 text-center max-w-xl m-auto pb-12 w-11/12 mx-auto">
          We’ll be opening up our public beta in November 2022. Get on the list
          now to be one of the first to use Survyy and lock in lower pricing.
        </p>
        <div className="w-11/12 max-w-xs mx-auto">
          <a
            href="#early-access"
            className="rounded-3xl  py-2 px-4 text-white marketing-btn-gradient"
          >
            get early access
          </a>
        </div>
      </div>
    </>
  );
}
